import * as moment from "moment";
import { TaskTypes } from "@teamprevent/common/task/taskActions/models";

import { Location } from "redux-little-router";

export const TASK_TYPE_OPTIONS = [
    {
        text: "General Admin Task",
        value: TaskTypes.GeneralAdminTask,
    },
    {
        text: "General Clinical Task",
        value: TaskTypes.GeneralClinicalTask,
    },
    {
        text: "General Billing Task",
        value: TaskTypes.GeneralBillingTask,
    }
];

export interface TaskCodeListModel {
    readonly id: string;
    readonly name: string;
    readonly taskType: string;
    readonly listUpdated?: moment.Moment;
}

export interface TaskCodeDetailModel extends TaskCodeListModel {
    readonly detailUpdated?: moment.Moment;
}

export type TaskCode = TaskCodeListModel & TaskCodeDetailModel;

export interface TaskCodeCreateModel {
    id: string;
    name: string;
    taskType: string;
}

export interface TaskCodeEditModel {
    id: string;
    name: string;
    taskType: string;
}

export interface TaskCodeState {
    readonly taskCodes: TaskCode[];
    readonly taskCode?: TaskCode;
}

export type AppState = TaskCodeState & { router: Location };
